import * as React from 'react';
import * as classnames from 'classnames';
import ReactSelectClass from 'react-select';

export interface SelectOption {
	label: string;
	value: string;
}

interface Props {
	allowedOptions: SelectOption[];
	selectedOption: string;
	disabled: boolean;
	title: string;
	className?: string;
	containerClassName?: string;
	onChange(selected: string): void;
}

export default class Select extends React.Component<Props, {}> {

	constructor(props: Props, context: any) {
		super(props, context);
		this.handleChange = this.handleChange.bind(this);
	}

	public render() {
		const className = classnames('select', this.props.className || '');
		return <div className={this.props.containerClassName}>
			<label>{this.props.title}</label>
			<ReactSelectClass
				options={this.props.allowedOptions}
				value={this.props.selectedOption}
				disabled={this.props.disabled}
				onChange={this.handleChange}
				className={className}
				clearable={false}
			/>
		</div>;
	}

	private handleChange(selectedOption: SelectOption) {
		const value = selectedOption ? selectedOption.value : null;
		this.props.onChange(value);
	}

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/util/widgets/Select.tsx